import { ERC20 } from 'src/common/types/models/Tokens'
import { BASE_KNOWN_ERC20 } from './consts'

export const ETHEREUM_KNOWN_TOKENS: Record<string, ERC20> = {
  SMT: {
    id: '0xB17548c7B510427baAc4e267BEa62e800b247173',
    contractAddress: '0xB17548c7B510427baAc4e267BEa62e800b247173', // Замените на реальный адрес
    name: 'Swarm Markets',
    symbol: 'SMT',
    decimals: 18,
    ...BASE_KNOWN_ERC20,
    logo: '',
  },
  WBTC: {
    id: '0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599',
    contractAddress: '0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599',
    name: 'Wrapped Bitcoin',
    symbol: 'WBTC',
    decimals: 8,
    ...BASE_KNOWN_ERC20,
    logo: '',
  },
  USDC: {
    id: '0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48',
    contractAddress: '0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48',
    name: 'USD Coin',
    symbol: 'USDC',
    decimals: 6,
    ...BASE_KNOWN_ERC20,
    logo: 'https://static.alchemyapi.io/images/assets/3408.png',
  },
  USDT: {
    id: '0xdAC17F958D2ee523a2206206994597C13D831ec7',
    contractAddress: '0xdAC17F958D2ee523a2206206994597C13D831ec7',
    name: 'Tether USD',
    symbol: 'USDT',
    decimals: 6,
    ...BASE_KNOWN_ERC20,
    logo: 'https://static.alchemyapi.io/images/assets/825.png',
  },
  DAI: {
    id: '0x6B175474E89094C44Da98b954EedeAC495271d0F',
    contractAddress: '0x6B175474E89094C44Da98b954EedeAC495271d0F',
    name: 'Dai Stablecoin',
    symbol: 'DAI',
    decimals: 18,
    ...BASE_KNOWN_ERC20,
    logo: 'https://static.alchemyapi.io/images/assets/4943.png',
  },
}
